import React from 'react';
import { FaCheckCircle, FaMapMarkerAlt } from 'react-icons/fa';

const LocalSeo = () => {
    const keyServices = [
        "Dépannage électrique d'urgence",
        "Rénovation et mise aux normes NF C 15-100",
        "Pose de tableaux électriques et domotique"
    ];

    return (
        <section id="entreprise-electricite-la-reunion" className="section local-seo-section">
            <div className="local-seo-container">
                <h2 className="section-title">Votre Entreprise d'Électricité de Proximité à La Réunion</h2>
                
                <div className="local-seo-grid">
                    <div className="local-seo-text">
                        <p>
                            Implantée au cœur du Tampon, <strong>TechniServices</strong> est votre entreprise d'électricité de référence à La Réunion. 
                            Que vous soyez un particulier ou un professionnel, je mets mon savoir-faire d'artisan qualifié au service de tous vos projets électriques avec réactivité, rigueur et tarifs transparents.
                        </p>
                        <p>
                            J’interviens quotidiennement sur <strong>Le Tampon et ses environs</strong>. 
                            De la mise en sécurité de vos installations anciennes à l'intégration de solutions domotiques modernes, Je vous garantis un accompagnement sur mesure et des réalisations durables conformes aux exigences de sécurité.
                        </p>
                    </div>

                    <div className="local-seo-services">
                        <h3>
                            <FaMapMarkerAlt style={{ color: 'var(--accent-yellow)' }} />
                            Interventions zone Tampon et ses environs
                        </h3>
                        <ul className="local-seo-list">
                            {keyServices.map((service, index) => (
                                <li key={index}>
                                    <FaCheckCircle className="check-icon" />
                                    <span>{service}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LocalSeo;
